import { useTranslation } from "react-i18next";
import { Briefcase } from "lucide-react";
import { normalizeWorkExperience } from "@/features/talent/utils";
import { ExperienceEntry } from "./Experience/ExperienceEntry";
import { ExpertiseSection } from "./Experience/ExpertiseSection";

interface TalentExperienceViewProps {
  profile: any;
}

export function TalentExperienceView({ profile }: TalentExperienceViewProps) {
  const { t } = useTranslation(["talent", "common"]);

  // Normalize experience data using the existing utility
  const { entries: experiences, areas_of_expertise } = normalizeWorkExperience(
    profile.work_experience
  );

  if (!experiences.length && !areas_of_expertise) {
    return (
      <div className="text-center p-8 text-gray-500 bg-white rounded-lg border border-dashed">
        <Briefcase className="mx-auto h-12 w-12 text-gray-300 mb-3" />
        <p>{t("common:no_data_available")}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-4xl">
      {/* Areas of Expertise Section */}
      {areas_of_expertise && (
        <ExpertiseSection expertise={areas_of_expertise} />
      )}

      {/* Experience Timeline Section */}
      {experiences.length > 0 && (
        <div className="space-y-6">
          <h3 className="text-lg font-semibold flex items-center gap-2 text-gray-900">
            {t("talent:experience.title")}
          </h3>

          <div className="relative pl-8 space-y-8 before:absolute before:left-3 before:top-2 before:bottom-0 before:w-0.5 before:bg-gray-200">
            {experiences.map((exp: any, index: number) => (
              <ExperienceEntry key={exp.id || index} exp={exp} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
